import styled, { css } from "styled-components";

export const CommonStyledPopOverCardCss = css`
  background: var(--White, #fff);
  border-radius: 4px;
  border: 1px solid var(--PEARL, #ecf1f4);
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.05));
  font-size: 14px;
  position: absolute;
  z-index: 2;
`;

export const StyledPopoverCard = styled.div`
  ${CommonStyledPopOverCardCss};
  box-shadow:
    0px 3px 6px -4px rgba(0, 0, 0, 0.12),
    0px 6px 16px 0px rgba(0, 0, 0, 0.08),
    0px 9px 28px 8px rgba(0, 0, 0, 0.05);

  &.instruction {
    background: var(--SKY, #cce5ff);
    border-radius: 8px;
    box-shadow: unset;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 24px 16px;
    width: 320px;
    max-height: 85vh;
    overflow-y: auto;
  }

  &.bulk-field-error {
    padding: 24px 16px;
    border-radius: 8px;
    background: #fcc;
    box-shadow: unset;
    position: relative;
  }
`;

export const StyledPopoverCardWithOutPortal = styled.div`
  ${CommonStyledPopOverCardCss};
  box-shadow: unset;
  left: 16px;
  width: calc(100% - 32px);
`;
